"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvailableTimesMapper = void 0;
var AvailableTimesMapper = /** @class */ (function () {
    function AvailableTimesMapper(data) {
        this.localData = data;
    }
    AvailableTimesMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return AvailableTimesMapper;
}());
exports.AvailableTimesMapper = AvailableTimesMapper;
//# sourceMappingURL=AvailableTimesMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/AvailableTimesMapper.js
// module id = 2083
// module chunks = 8